// extracted by mini-css-extract-plugin
module.exports = {"header":"terms-agreement_header__9bBqB","box":"terms-agreement_box__9N2V3","title":"terms-agreement_title__1ssZf"};